export default __webpack_public_path__ + "12f63006017db8bd402a93ca979abeef.gif";